
class Environment {
	static config = require('../config/' + process.env.NODE_ENV)
}

export default Environment
